import { render } from "./EvaluationComments.vue?vue&type=template&id=dc47efba&scoped=true"
import script from "./EvaluationComments.vue?vue&type=script&lang=js"
export * from "./EvaluationComments.vue?vue&type=script&lang=js"

import "./EvaluationComments.vue?vue&type=style&index=0&id=dc47efba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc47efba"]])

export default __exports__